export const UserCapabilities = {
  UseLeashApp: 'use-leash-application',
  UsePricingApp: 'use-pricing-application',
  UsePupDocsApp: 'use-pupdocs-application',
  UseDogParkApp: 'use-dog-park-application',
} as const;
